let tracker;

function getTracker() {
    if (tracker) {
        return tracker;
    }

    if (window.pulse) {
        window.pulse((trackerInstance) => tracker = trackerInstance);

        return tracker;
    }

    return null;
}

export async function trackEngagement(id, name) {
    const tracker = getTracker();

    if (!tracker) {
        return;
    }

    tracker.track('engagementEvent', {
        type: 'Engagement',
        object: {
            type: 'UIElement',
            '@id': 'sdrn:e24:content:bensinkalkulator:element:' + id,
            contentId: id,
            elementType: 'bensinkalkulator',
            name,
        }
    });
}

export async function trackImpression() {
    const tracker = getTracker();

    if (!tracker) {
        return;
    }

    tracker.track('trackerEvent', {
        type: 'View',
        object: {
            type: 'UIElement',
            '@id': 'sdrn:e24:content:bensinkalkulator:element:bensinkalkulator',
            contentId: 'bensinkalkulator',
            elementType: 'bensinkalkulator',
        }
    });
}
